// 封装统一的接口地址 
// 8080   
const api = {
    login: "login",  //登录
    submit: "submit",// 注册
    send_code: "send_code",//验证码
    apply_code: "apply_code",//验证码注册   
    bar_list: "bar_list",// 网吧列表
    add_bar: "add_bar", // 创建新网吧列表
    bar_order_list: "bar_order_list", // 渠道流水
    province: "province",  //获取所有的省份
    city: 'city',  //获取所有的市传id
    county: "county",  //获取所有的区县传id
    apply_county: "apply_county",  //点击申请
    apply_district_list: "apply_district_list",   //代理查看自己的区域独代申请记录
    submit_district: "submit_district",    //submit_district 提交审核代理
    delete_notice: "delete_notice",    //删除公告
    apply_list: "apply_list", //申请记录
    read_manage: "read_manage",  //管理员经理分配
    one_register: "one_register",      //账号注册审核表           在这里页面 registrationSurface
    update_county: "update_county",   //管理员设置为独代区域和多代区域 
    create_manege: "create_manege", // 新增区域经理
    search_district:"search_district",  //搜索区域 县区
    district_now_agent:"district_now_agent", // 搜索区域 县区 出现的列表
    manage_to_agent: "manage_to_agent",  //渠道列表    空数据
    delete_one_county:"delete_one_county", // 删除区域  //删除区域delete_one_county
    notice: "notice",     //查看公告  官方消息    如果是get请求那么就是 公告列表     如果是post请求就是新建公告 
    next_agent_sum_order: "next_agent_sum_order", // 渠道数据   
    day_month_money:"day_month_money",  //首页的代理查看包月的网吧充值，今日，本周，本月，总共充值
    month_all_money:"month_all_money", //报表
    delete_bar:"delete_bar",   //删除网吧
    add_bar_ip:"add_bar_ip",  //新增网吧ip地址 编辑
    bar_count:"bar_count", // 查看自己开通网吧数量信息
    set_pwd:"set_pwd",//修改密码
    county:"county",  //查看所有的区县  比返回全部的市
    get_barId:"get_barId",    // 随机生成网吧id
    read_qq:"read_qq",  //获取官方群
    read_mac:"read_mac",    //查看有效终端的列表数据，默认查看今天server_model.MacReadSm
    open_close:"open_close",  // 有效终端开关server_model.ChannelOpenClose
    month_day_mac:"month_day_mac", //查看昨天，今天，本月有效终端的数据
    update_bar_district:"update_bar_district", // 修改区域
    update_run_bar:"update_run_bar",   // 动态网吧
    remain_money:"remain_money", //  包月账户可用余额
    remain_order:"remain_order",    // 通过余额 计算
    add_bar_ip:"add_bar_ip",    // 静态网吧增加ip
  
    // 扫码后台 端口 8004  instance2
    bar_downloads:"bar_downloads", //包月后台
    sm_downloads:"sm_downloads", //扫码后台
  
  
  
  //  本地的8081端口地址  instance3
    create_order:"create_order",   //订单接口 二维码
    status:"status", // 订单状态 1秒钟调用一次
    
  }
  
  export default {
    api
  }
  
  
  